import { ExternalLink } from "lucide-react";
import { Reveal, ChapterHeading } from "./Reveal";
import { SITE } from "../data/site";

export default function CityMap({ loc }) {
  const q = encodeURIComponent(`${loc.name}, ${loc.county}, England`);
  return (
    <section className="border-t border-white/10 py-16 sm:py-20" data-testid="city-map">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <ChapterHeading number="03" label="ON THE MAP" />
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 items-start">
          <Reveal>
            <h2 className="font-display font-extrabold uppercase tracking-tight text-3xl sm:text-4xl text-white leading-tight">
              Covering every corner of {loc.name}
            </h2>
            <p className="mt-5 text-sm sm:text-base text-gray-400 leading-relaxed">
              Our patrol vehicles and response units operate across {loc.name}{" "}
              and {loc.county === "Greater London" ? "the wider capital region" : `greater ${loc.county}`} around the clock. If your site is on this
              map, we can have licensed officers, patrols or monitored towers
              protecting it — usually within days, urgently within hours.
            </p>
            <p className="mt-4 font-mono text-[10px] uppercase tracking-widest text-amber">
              Free site survey anywhere in {loc.county}
            </p>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-2">
            <div className="relative border border-white/10 p-2 bg-card">
              <div className="absolute -top-1 -left-1 w-5 h-5 border-t-2 border-l-2 border-amber z-10"></div>
              <div className="absolute -bottom-1 -right-1 w-5 h-5 border-b-2 border-r-2 border-amber z-10"></div>
              <iframe
                title={`Map of ${loc.name}, ${loc.county} — Xtreme Protection coverage area`}
                src={`https://www.google.com/maps?q=${q}&z=11&output=embed`}
                className="w-full h-72 sm:h-96 grayscale-[30%] contrast-[1.05]"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="city-map-iframe"
              ></iframe>
            </div>
            <a
              href={SITE.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="city-gbp-link"
              className="group mt-3 flex items-center justify-between gap-3 border border-amber/30 bg-card px-5 py-4 hover:border-amber transition-colors duration-300"
            >
              <span className="font-display font-bold uppercase tracking-wide text-sm text-white group-hover:text-amber transition-colors">
                Xtreme Protection on Google Maps
              </span>
              <ExternalLink className="w-4 h-4 text-amber shrink-0" />
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
